var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M1.123 15.828a.552.552 0 01-.4.165.566.566 0 01-.4-.965L7.353 8 .324.972a.566.566 0 01.799-.8L8.55 7.6c.22.22.22.58 0 .8l-7.428 7.428z","fill":"#fff"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h8.889v16H0z"})))]);
}

RightArrow.defaultProps = {"width":"9","height":"16","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
